import React, { useContext, useState } from 'react';
import useCalendarRequestService from '../../../app/services/hooks/useCalendarRequestService';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    CalendarRequestId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const CalendarRequestSwitchChange = ({ CalendarRequestId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = useState<boolean>(checkValue);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeCalendarRequest, fetchingActiveCalendarRequest } = useCalendarRequestService();

    const active = (value: boolean) => {
        setChecked(value);

        activeCalendarRequest(CalendarRequestId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={CalendarRequestId} callback={active} />;
};

export default CalendarRequestSwitchChange;
